import { createStore } from 'zustand';

export type LoginDocumentNumberState = {
  loginDocumentNumber: string;
};

export const loginDocumentNumberStore = createStore<LoginDocumentNumberState>(() => {
  return {
    loginDocumentNumber: '',
  };
});

export const setLoginDocumentNumber = async (documentNumber: string) => {
  loginDocumentNumberStore.setState({ loginDocumentNumber: documentNumber });
};

export const resetLoginDocumentNumber = async () => {
  loginDocumentNumberStore.setState(loginDocumentNumberStore.getInitialState(), true);
};
